




























import { Vue, Component } from 'vue-property-decorator'
import DisabledTextInput from '@/UI/Shared/DisabledTextInput.vue'
import { namespace } from 'vuex-class'
import { RepresentationData } from '@/Infrastructure/Store/Auction/RepresentationData'

const auctionStore = namespace('auction')

@Component({
  components: { DisabledTextInput }
})

export default class RepresentationForm extends Vue {
  @auctionStore.Getter
  public representationData!: RepresentationData
}
